import { HttpClient, RequestParams } from "../../utils/api/http-client";
import { IGenerateOtpRequest } from "../../models/otp/request";
import { IGenerateOtpResponse, IOtpLogsResponse } from "../../models/otp/response";

class OtpService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * Generate OTP for a mobile number
   * POST /api/otp/generate
   */
  generateOtp = (data: IGenerateOtpRequest, params?: RequestParams) =>
    this.http.request<IGenerateOtpResponse>({
      path: "/otp/generate",
      method: "POST",
      body: data,
      ...params,
    });

  /**
   * Fetch OTP logs
   * GET /api/otp/logs
   */
  fetchLogs = (limit: number = 20, params?: RequestParams) =>
    this.http.request<IOtpLogsResponse>({
      path: `/otp/logs?limit=${limit}`,
      method: "GET",
      ...params,
    });
}

export default OtpService;
